import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

// La memoria del proyecto: notas que el Orquestador anotó (o tú) y que recuerda en cada conversación.
export function useMemory(projectId, enabled = true) {
  return useQuery({
    queryKey: ["memory", projectId],
    queryFn: async () => (await apiClient.get(`/projects/${projectId}/memory`)).data,
    enabled: !!projectId && enabled,
    retry: false,
  });
}

export function useAddMemory(projectId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ kind, text }) => (await apiClient.post(`/projects/${projectId}/memory`, { kind, text })).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["memory", projectId] }),
  });
}

export function useDeleteMemory(projectId) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (noteId) => (await apiClient.delete(`/projects/${projectId}/memory/${noteId}`)).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["memory", projectId] }),
  });
}
